// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"; // 🔐 Add this

const firebaseConfig = {
  apiKey: "AIzaSyDfYQY5W1yIvQN3SyF_QSTDGHiza9AA-48",
  authDomain: "ideator-engg.firebaseapp.com",
  projectId: "ideator-engg",
  storageBucket: "ideator-engg.firebasestorage.app",
  messagingSenderId: "142634131104",
  appId: "1:142634131104:web:b8c126406c331e2f58f3c5",
  measurementId: "G-0PL14GDVT6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firestore & Auth references
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
